// ProjectContext.js — thin re-export from AppDataContext
import React from 'react';
import { useAppData } from './AppDataContext';

export const useProject = () => {
  const appData = useAppData();
  return {
    projects: appData.projects,
    activeProject: appData.activeProject,
    loading: appData.loading,
    error: appData.error,
    fetchProjects: appData.refreshOrganizations,
    selectProject: appData.selectProject,
    createProject: appData.createProject,
    updateProject: appData.updateProject,
    deleteProject: appData.deleteProject,
  };
};

export const ProjectProvider = ({ children }) => <>{children}</>;
